export const appState = {
    power: 'ON',
    display: 'Power: ON',
    volume: 0.5,
    bank: 'Heater',
};

